import { render, staticRenderFns } from "./ChatNameInput.vue?vue&type=template&id=2d138525&lang=pug&"
import script from "./ChatNameInput.vue?vue&type=script&lang=js&"
export * from "./ChatNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatNameInput.vue"
export default component.exports